import React, { useState } from "react";
import { post } from "helpers/api_helper";
import { useEffect } from "react";
import { ImageBaseUrl } from "helpers/file_upload_helper";
import { Label } from "reactstrap";
import Loader from "./loader";
import toastr from "toastr";

const MAX_UPLOAD_MB = 20;

// Stored paths are relative ("shipmentTypes/x.png"); older records may already hold a full URL.
const toImageUrl = (path) => /^https?:\/\//.test(path) ? path : `${ImageBaseUrl}${path}`;

const UploadImage = props => {

    const [loading, setLoading] = useState(false);
    const [filePathUrl, setFilePathUrl] = useState('');
    const [filePath, setfilePath] = useState('');
    const [InputLabel, setInputLabel] = useState('');
    const [InputWidth, setInputWidth] = useState('4');
    const [type, setType] = useState('');

    useEffect(() => {
        if (props.state) {
            setType(props.state.type);
            setfilePath(props.state.filePath);
            setInputLabel(props.state.InputLabel);
            setInputWidth(props.state.InputWidth);
            setFilePathUrl(toImageUrl(props.state.filePath));
        }
    }, []);

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;
        if (file.size > MAX_UPLOAD_MB * 1024 * 1024) {
            toastr.error(`File too large (max ${MAX_UPLOAD_MB} MB)`);
            event.target.value = '';
            return;
        }
        setLoading(true);
        post('general/upload-image', { file, type }, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then((response) => {
                const data = response.data;
                setfilePath(data.path);
                setFilePathUrl(toImageUrl(data.path));
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
                event.target.value = '';
                toastr.error(error?.response?.data?.message || 'Upload failed');
            });
    }

    return (
        <div className={`form-group col-md-${InputWidth} mt-2`}>
            <Label className="form-label">{InputLabel}</Label>
            <input className="form-control" type="file" onChange={handleFileUpload} />
            <input type="hidden" name="imagePath" id="imagePath" value={filePath}></input>
            <br></br>
            {loading ? <Loader></Loader> : null}
            {filePath ? (<img src={`${filePathUrl}`} width={220} style={{ padding: "20px", background: "#f5f5f5", borderRadius: "5px" }}></img>) : null}
        </div >
    );
}

export default UploadImage;
